import { isMobile } from '@pascal/pascal-core';
import { containerNames } from '../../../enums/containerNames';
import { PixiBase } from '../../../core/pixi/PixiBase';
import { gameResourceNames } from '../../../core/pixi/resources';
import { Spine } from '../../../services/spine';
import { BACKGROUND_ANIMATION_NAME } from '../../../core/constants/gameLayers';
import { mobileGameConfigs, webGameConfigs } from '../../../core/pixi/config';

export class BackgroundDrawer {
  constructor() {
    this.animations = {};
    this.backgroundContainer = PixiBase.createContainer(containerNames.backgroundContainer);
  }

  setupBackground() {
    this.background = new Spine({ key: gameResourceNames.background });

    if (isMobile()) {
      const { width, height } = mobileGameConfigs;

      PixiBase.setPosition(this.background, { x: width / 2, y: height / 2 });
    } else {
      const { width, height } = webGameConfigs;

      PixiBase.setPosition(this.background, { x: width / 2, y: height / 2 });
    }
    this.playBackgroundStaticAnimation();
    this.backgroundContainer.addChild(this.background);
  }

  playBackgroundStaticAnimation() {
    this.background.play(BACKGROUND_ANIMATION_NAME.Idle, true);
  }

  playBackgroundShakeAnimation() {
    this.background.play(BACKGROUND_ANIMATION_NAME.Shake, false, 1);
  }

  execute(config) {
    this.config = config;
    this.setupBackground();
  }
}
